import React from 'react'

import ActivityExpenseSelector from '../components/ActivityExpenseSelector'
import RemoveButton from '../components/controls/RemoveButton'

import DatePicker from './controls/DatePicker'
import CustomDropDown from './CustomDropDown'

const Expense = ({
  namePrefix,
  model,
  setModelFunction,
  createInputProps,
  onChangeHandler,
  expenseIsMileage,
  ErrorMessage,
  handleRemove,
  allowEditing = true,
  caseMemberOptions = [],
}) => {
  const handleChange = e => onChangeHandler(e, namePrefix)

  return (
    <div className="expense clearfix">
      <div className="form-row">
        <div className="col-md-2">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.type`}>
              Date
            </label>
            <DatePicker
              readOnly={!allowEditing}
              className="form-control"
              {...createInputProps({ name: `${namePrefix}.date`, model, setModelFunction })}
            />
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.type`}>
              Type of Expense
            </label>
            <ActivityExpenseSelector
              allowEditing={allowEditing}
              className="form-control"
              {...createInputProps({
                name: `${namePrefix}.type`,
                model,
                setModelFunction,
                onChangeHandler: handleChange,
              })}
              type="expense"
            />
          </div>
        </div>
        <div className="col-md-1">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.amount`}>
              Amount
            </label>
            <div className="input-icon input-icon-left">
              <input
                readOnly={allowEditing ? null : true}
                className="form-control"
                {...createInputProps({
                  name: `${namePrefix}.amount`,
                  model,
                  setModelFunction,
                  onChangeHandler: handleChange,
                })}
                type="number"
                disabled={expenseIsMileage}
                onKeyDown={e => (e.key === 'e' || e.key === '-') && e.preventDefault()}
              />
              <i>$</i>
            </div>
          </div>
        </div>
        <div className="col-md-1">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.distance`}>
              Distance
            </label>
            <div className="input-icon input-icon-right">
              <input
                readOnly={allowEditing ? null : true}
                className="form-control"
                {...createInputProps({
                  name: `${namePrefix}.distance`,
                  model,
                  setModelFunction,
                  onChangeHandler: handleChange,
                })}
                type="number"
                disabled={!expenseIsMileage}
                onKeyDown={e => (e.key === 'e' || e.key === '-') && e.preventDefault()}
              />
              <i>mi</i>
            </div>
          </div>
        </div>
        {/* Description — col-md-3 */}
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.description`}>
              Description
            </label>
            <input
              readOnly={allowEditing ? null : true}
              className="form-control"
              {...createInputProps({
                name: `${namePrefix}.description`,
                model,
                setModelFunction,
                onChangeHandler: handleChange,
              })}
            />
          </div>
        </div>

        {/* Case Member — col-md-2 */}
        <div className="col-md-2">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.userId`}>
              Case Member
            </label>
            <CustomDropDown
              id={`${namePrefix}.userId`}
              name={`${namePrefix}.userId`}
              allowEditing={allowEditing}
              className="drop-down-container"
              items={caseMemberOptions}
              placeholderText="Select Member"
              noOptionsMessage="No members found"
              {...createInputProps({
                name: `${namePrefix}.userId`,
                model,
                setModelFunction,
              })}
            />
          </div>
        </div>

        {/* Actions — col-md-1 */}
        <div className="col-md-1">
          <div className="form-group">
            <div className="form-label mt-2 d-md-none">&nbsp;</div>
            <div className="d-flex align-items-center justify-content-end" style={{ height: '38px' }}>
              {allowEditing && (
                <RemoveButton
                  id={`${namePrefix}RemoveBtn`}
                  className="hide-sm-down"
                  onClick={handleRemove}
                ></RemoveButton>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-2">
        <ErrorMessage name={`${namePrefix}.date`} model={model} />
        <ErrorMessage name={`${namePrefix}.type`} model={model} />
        <ErrorMessage name={`${namePrefix}.amount`} model={model} />
        <ErrorMessage name={`${namePrefix}.distance`} model={model} />
        <ErrorMessage name={`${namePrefix}.userId`} model={model} />
        <ErrorMessage name={`${namePrefix}.description`} model={model} />
      </div>
      {allowEditing && (
        <RemoveButton id={`${namePrefix}.RemoveBtn-Large`} className="show-sm-down float-right" onClick={handleRemove}>
          Remove
        </RemoveButton>
      )}
    </div>
  )
}

export default Expense
